// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"OrderContent--next-sr-only--1Zl-ZmV","content":"OrderContent--content--3ajtGfN"};